import { Button, CenterPopup, Image, Modal, Toast } from 'antd-mobile';
import { useThrottledHandler } from 'App';
import img from 'app/img';
import { useEffect, useState } from 'react';
import {
    AiFillChrome,
    AiFillCloud,
    AiFillHome,
    AiOutlineChrome,
    AiOutlineCloud,
    AiOutlineHome,
    AiOutlineRadarChart,
    AiOutlineUser,
    AiOutlineVideoCamera,
} from 'react-icons/ai';
import { HiOutlineUser, HiUser } from 'react-icons/hi2';
import { useLocation, useNavigate } from 'react-router-dom';
import { TermsNodeListDT } from 'services/apis/cnt2/term-api';
import { UserPolyInfoDT } from 'services/apis/sys/user-api';
import { getItemWithExpiration } from 'utils/localStorageUtil';
import { scrollTop } from 'utils/screenUtil';
import styles from './index.module.scss';

const BottomNav = (data: { onClick: (key: string) => void; className: string; activeIndex?: number }) => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(data.activeIndex || 0);
  const userPolyInfo = getItemWithExpiration('userPolyInfo') as UserPolyInfoDT;

  // 监听路由，修改底部导航当前值
  // useEffect(() => {
  //   if (useLocation().pathname.endsWith('one/home')) {
  //     setActiveIndex(1);
  //   }
  // }, []);

  type NavDT = {
    termId?: string;
    term?: TermsNodeListDT;
    url: string;
    icon: any;
    label: string;
    iconActived: any;
    show: boolean;
    open: boolean;
    allowVipList: string[];
    allowVipLevelList: number[];
  };
  const navList: NavDT[] = [
    {
      url: '/one/test',
      label: '测试',
      icon: (
        <img
          width={24}
          src={require('assets/icon/nav_home.png')}
          className=" invert"
        />
      ),
      iconActived: (
        <img
          width={24}
          src={require('assets/icon/nav_home_selected.png')}
        />
      ),
      open: true,
      show: false,
      allowVipList: null,
      allowVipLevelList: null,
    },
    {
      url: '/one/osusume',
      label: '首页',
      icon: (
        <img
          width={24}
          src={require('assets/icon/nav_home.png')}
          className=" invert"
        />
      ),
      iconActived: (
        <img
          width={24}
          src={require('assets/icon/nav_home_selected.png')}
        />
      ),
      open: true,
      show: true,
      allowVipList: null,
      allowVipLevelList: null,
    },
    {
      termId: 'CAT_1',
      url: '/one/home',
      label: '次元',
      icon: (
        <img
          width={24}
          src={require('assets/icon/nav_start.png')}
          className=" invert"
        />
      ),
      iconActived: (
        <img
          width={24}
          src={require('assets/icon/nav_start_selected.png')}
        />
      ),
      open: true,
      show: true,
      allowVipList: ['次元会员', '全站通'],
      allowVipLevelList: [11, 12, 13, 14, 41, 42, 43, 44],
    },
    {
      termId: 'CAT_2',
      url: '/one/home',
      label: '福利',
      icon: (
        <img
          width={24}
          src={require('assets/icon/nav_vlog.png')}
          className=" invert"
        />
      ),
      iconActived: (
        <img
          width={24}
          src={require('assets/icon/nav_vlog_selected.png')}
        />
      ),
      open: false,
      show: true,
      allowVipList: ['福利会员', '全站通'],
      allowVipLevelList: [21, 22, 23, 24, 41, 42, 43, 44],
    },
    {
      termId: 'CAT_3',
      url: '/one/home',
      label: '暗网',
      icon: (
        <img
          width={24}
          src={require('assets/icon/nav_tx.png')}
          className=" invert"
        />
      ),
      iconActived: (
        <img
          width={24}
          src={require('assets/icon/nav_tx_selected.png')}
        />
      ),
      open: false,
      show: true,
      allowVipList: ['暗网会员', '全站通'],
      allowVipLevelList: [31, 32, 33, 34, 41, 42, 43, 44],
    },
    {
      url: '/one/square',
      label: '社区',
      icon: (
        <img
          width={24}
          src={require('assets/icon/nav_community.png')}
          className=" invert"
        />
      ),
      iconActived: (
        <img
          width={24}
          src={require('assets/icon/nav_community_selected.png')}
        />
      ),
      open: false,
      show: true,
      allowVipList: ['全站通'],
      allowVipLevelList: [41, 42, 43, 44],
    },
    {
      url: '/one/mine',
      label: '我的',
      icon: (
        <img
          width={24}
          src={require('assets/icon/nav_mine.png')}
          className=" invert"
        />
      ),
      iconActived: (
        <img
          width={24}
          src={require('assets/icon/nav_mine_selected.png')}
        />
      ),
      open: true,
      show: true,
      allowVipList: null,
      allowVipLevelList: null,
    },
  ];

  const [darkwebTipVisible, setDarkwebTipVisible] = useState(false);

  return (
    <>
      <CenterPopup
        closeOnMaskClick={true}
        showCloseButton={false}
        onClose={() => {
          setDarkwebTipVisible(false);
        }}
        className={styles.mystyle}
        style={{ zIndex: 1001 }}
        visible={darkwebTipVisible}
      >
        <div className=" p-6 flex flex-col gap-6 bg-transparent">
          <Image
            src={img.darkwebTipImg}
            fit="cover"
          />
          <Image
            src={img.darkwebVipBuyImg}
            fit="cover"
            onClick={useThrottledHandler(() => {
              // navigate('/one/mine');
              // setActiveIndex(navList.filter((nav) => nav.show).length - 1);
              setDarkwebTipVisible(false);
            })}
          />
        </div>
      </CenterPopup>
      <div className={[data.className, styles.bottom_nav].join(' ')}>
        <div className=" flex justify-between items-center bg-slate-100">
          {navList
            ?.filter((item) => item.show)
            .map((item, index) => (
              <div
                key={item.label}
                className={[
                  ' flex flex-grow flex-col justify-center items-center pt-2 pb-1 cursor-pointer opacity-90',
                ].join(' ')}
                onClick={() => {
                  scrollTop();

                  // vip鉴权
                  if (item.allowVipLevelList && item.allowVipLevelList.length != 0) {
                    const vipLevelList = userPolyInfo.vipList
                      .filter((vip) => vip.usergroupActiveStatus == 1)
                      .map((vip) => vip.usergroupLevel);
                    let allow = false;
                    vipLevelList.forEach((vipLevel) => {
                      if (item.allowVipLevelList.includes(vipLevel)) {
                        allow = true;
                      }
                    });
                    if (!allow) {
                      Modal.show({
                        closeOnAction: true,
                        closeOnMaskClick: true,
                        title: '暂无权限',
                        content: (
                          <div className=" text-pink-500/80 text-center font-bold">
                            {'请开通' + item.allowVipList.map((item) => '【' + item + '】').join('或')}
                          </div>
                        ),
                        actions: [
                          {
                            key: 'levelup',
                            text: (
                              <div
                                className=" bg-gradient-to-r from-violet-500 to-fuchsia-500 shadow-md rounded-md text-white p-2 mb-8 text-base"
                                onClick={() => {
                                  navigate('/one/mine');
                                  setActiveIndex(navList.filter((nav) => nav.show).length - 1);
                                }}
                              >
                                限时开通
                              </div>
                            ),
                          },
                          {
                            key: 'img',
                            text: (
                              <>
                                <div className=" pointer-events-none w-full z-0 absolute ring-0 -bottom-3 flex justify-end items-center">
                                  <img
                                    src={img.cute_cat}
                                    className=" w-20 h-16 object-cover object-top mr-4"
                                  />
                                </div>
                              </>
                            ),
                          },
                        ],
                      });
                      // 暗网提示
                      if (item.termId === 'CAT_3') {
                        setDarkwebTipVisible(true);
                      }
                      return;
                    }
                  }

                  // 是否开放
                  if (item?.open) {
                    navigate(item.url, { state: { term: item?.term } });
                    setActiveIndex(index);
                    if (item.termId) {
                      data.onClick(item?.termId);
                      navigate(item.url);
                    }
                  } else {
                    // TODO 禁止点击, 有数据后再开放
                    Toast.clear();
                    Toast.show('❤ 暂无权限 ❤');
                  }
                }}
              >
                {activeIndex === index ? (
                  <>
                    <div className={' '}>{item.iconActived}</div>
                    <div className=" text-orange-400 text-[10px] mt-0.5 font-extrabold">{item.label}</div>
                  </>
                ) : (
                  <>
                    <div className={' '}>{item.icon}</div>
                    <div className=" text-slate-500 text-[10px] mt-0.5 font-extrabold">{item.label}</div>
                  </>
                )}
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default BottomNav;
